import * as _ from "lodash";
import * as angular from "angular";
import { Field } from "../../models/field.model";

let FieldIconComponent = {
    selector: "vcFieldIcon",
    templateUrl: "/angular/components/field/field-icon.component.html",
    bindings: {
        field: "=",
        color: "=",
        size: "=",
    },
    controller: class FieldIconController {
        // * bindings for typescript compiler *
        public field: any;
        public color: any;
        public size: any;
        // ************************************

        public readonly iconKeys = {
            homephone: "phone",
            mobilephone: "phone_android",
            email: "mail",
            gender: "wc",
            party: "flag",
            yob: "cake",
            dob: "cake",
            volunteer: "insert_emoticon",
            employment: "work",
            deceased: "airline_seat_individual_suite",
            donor: "monetization_on",
            credit_rating: "credit_score",
            donor_environmental: "energy_savings_leaf",
            income: "savings",
            custom: "layers",
        };
        public fieldSelected: Field;

        $onInit() {
            this.fieldSelected = _.cloneDeep(this.field);
            this.rewriteField();
        }

        rewriteField() {
            if (
                this.fieldSelected.hokey &&
                this.fieldSelected.hokey != "homephone" &&
                this.fieldSelected.hokey.substring(0, 2) == "ho"
            ) {
                this.fieldSelected.hokey =
                    this.fieldSelected.hokey.substring(2);
            } else {
                if (this.fieldSelected.hokey == "esname")
                    this.fieldSelected.hokey = "employment";
            }
        }
    },
};

angular
    .module("field", [])
    .component(FieldIconComponent.selector, FieldIconComponent);
